
import { useState, useEffect } from "react";
import { auth, provider } from "../../../firebase-config";
import { signInWithPopup, signOut } from "firebase/auth";
// react-router-dom components
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import TextField from '@mui/material/TextField';
// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";


// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { Icon } from "@mui/material";

const cookies = new Cookies();

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [authenticated, setAuthenticated] = useState(!!cookies.get("auth-token1"));
  const [info, setinfo] = useState("")
  const [successSB, setSuccessSB] = useState(false);
  const [infoSB, setInfoSB] = useState(false);
  const [warningSB, setWarningSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openInfoSB = () => setInfoSB(true);
  const closeInfoSB = () => setInfoSB(false);
  const openWarningSB = () => setWarningSB(true);
  const closeWarningSB = () => setWarningSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);


  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  useEffect(() => {
    const checkAuthentication = () => {
      setAuthenticated(!!cookies.get("auth-token1"));
    };

    // Listen for changes in authentication token
    checkAuthentication();

    // Cleanup
    return () => {
      // Clear any listeners if needed
    };
  }, []);
  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="SUCCESS"
      content="Sucessfully Signed In"
      dateTime="1 second ago"
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
      bgWhite
    />
  );

  const authenticate = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      cookies.set('auth-token1', JSON.stringify({ refreshToken: result.user.refreshToken, photoURL: auth?.currentUser?.photoURL, userName: auth?.currentUser?.displayName, userEmail: auth?.currentUser?.email, userInformation: info, userid: auth?.currentUser?.uid }), { sameSite: 'None', secure: true });
      openSuccessSB();
      setTimeout(() => {
        document.getElementById('aboutLink').click();
      }, 1500);
    } catch (err) {
      console.error(err);

    }
  }

  return (

    <BasicLayout image={bgImage}>
      {!authenticated ? (
        <>
          <Link id="aboutLink" to="/authentication/sign-up" style={{ display: 'none' }}>Go to About</Link>
          <Card>
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              mx={2}
              mt={-3}
              p={2}
              mb={1}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                Sign in
              </MDTypography>
              <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
                <Grid item xs={2}>
                  <MDTypography component={MuiLink} href="#" variant="body1" color="white" onClick={()=>
                    {
                      alert("Sign In with Google is only available")
                    }
                  }>
                    <FacebookIcon color="inherit" />
                  </MDTypography>
                </Grid>
                <Grid item xs={2}>
                  <MDTypography component={MuiLink} href="#" variant="body1" color="white" onClick={()=>
                    {
                      alert("Sign In with Google is only available")
                    }
                  }>
                    <GitHubIcon color="inherit" />
                  </MDTypography>
                  {/* {renderSuccessSB} */}
                </Grid>
                <Grid item xs={2}>
                  <MDTypography component={MuiLink} href="#" variant="body1" color="white" onClick={authenticate}>
                    <GoogleIcon color="inherit" />
                  </MDTypography>
                  {renderSuccessSB}
                </Grid>
              </Grid>
            </MDBox>
            <MDBox pt={4} pb={3} px={3}>
              <MDBox component="form" role="form">
                <MDBox mb={2}>
                  <TextField
                    id="outlined-multiline"
                    label="Personal Information"
                    multiline
                    rows={4}
                    variant="outlined"
                    style={{ width: '100%' }}
                    onChange={(event) => {
                      setinfo(event.target.value);
                    }}
                  />
                </MDBox>

                <MDBox display="flex" alignItems="center" ml={-1}>
                  <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    onClick={handleSetRememberMe}
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Remember me
                  </MDTypography>
                </MDBox>
                <MDBox mt={4} mb={1}>
                  <MDButton variant="gradient" color="info" fullWidth onClick={authenticate}>
                    sign in
                  </MDButton>
                </MDBox>
                
              </MDBox>
            </MDBox>
          </Card>
        </>
      ) : (
        <>
          <Card>
            <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              mx={2}
              mt={-3}
              p={2}
              mb={1}
              textAlign="center"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <MDTypography variant="h4" fontWeight="medium" color="white">
                Already Signed In
              </MDTypography>
              <FontAwesomeIcon icon={faCheckCircle} style={{ marginLeft: '10px', color: 'white' }} />
            </MDBox>
          </Card>

        </>
      )}
    </BasicLayout>
  );
}

export default Basic;
